/** @jsxImportSource @emotion/react */
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled'
import { TooltipWrapper } from 'components/atoms/TooltipWrapper'

interface Props {
  optedOut?: boolean | null
  /** Icon size in px. */
  size?: number
}

/**
 * Shows a "phone disabled" icon with hover text when a patient has opted out of automated
 * voice (Retell) calls. Renders nothing when the patient has not opted out.
 */
export const VoiceOptOutBadge = ({ optedOut, size = 16 }: Props) => {
  if (!optedOut) return null

  return (
    <TooltipWrapper text="Opted out of automated voice calls" show>
      <span css={{ display: 'inline-flex', alignItems: 'center', marginLeft: 4 }}>
        <PhoneDisabledIcon
          htmlColor="#C0392B"
          aria-label="Opted out of automated voice calls"
          css={{ fontSize: size }}
        />
      </span>
    </TooltipWrapper>
  )
}
